export const MOBILE_SIGNUP_INTRO_BODY_DELAY_MS = 650;
export const MOBILE_SIGNUP_INTRO_CHAR_REVEAL_MS = 11;
export const MOBILE_SIGNUP_INTRO_CHAR_SETTLE_MS = 420;
export const MOBILE_SIGNUP_INTRO_READING_HOLD_MS = 2000;
export const MOBILE_SIGNUP_INTRO_READING_MS_PER_WORD = 170;
export const MOBILE_SIGNUP_INTRO_MIN_STEP_MS = 4800;
export const MOBILE_SIGNUP_INTRO_FINAL_DELAY_MS = 420;
export const MOBILE_SIGNUP_INTRO_WELCOME_HOLD_MS = 1600;

export const getMobileSignupIntroBody = (step) =>
  (step?.bodyBlocks || []).flat().join(" ");

export const getMobileSignupIntroRevealUnitCount = (text) =>
  Array.from(String(text || "").trim()).length;

export const getMobileSignupIntroWordCount = (text) =>
  String(text || "").trim().split(/\s+/).filter(Boolean).length;

export const getMobileSignupIntroReadingHoldMs = (body) =>
  Math.max(
    MOBILE_SIGNUP_INTRO_READING_HOLD_MS,
    getMobileSignupIntroWordCount(body) * MOBILE_SIGNUP_INTRO_READING_MS_PER_WORD
  );

export const getMobileSignupIntroStepMs = (body) =>
  Math.max(
    MOBILE_SIGNUP_INTRO_MIN_STEP_MS,
    MOBILE_SIGNUP_INTRO_BODY_DELAY_MS +
      getMobileSignupIntroRevealUnitCount(body) * MOBILE_SIGNUP_INTRO_CHAR_REVEAL_MS +
      MOBILE_SIGNUP_INTRO_CHAR_SETTLE_MS +
      getMobileSignupIntroReadingHoldMs(body)
  );

export const createMobileSignupIntroRun = (steps) => {
  const frozenSteps = (steps || []).map((step) => ({
    ...step,
    bodyBlocks: (step?.bodyBlocks || []).map((block) => [...block]),
  }));
  const stepDurations = frozenSteps.map((step) =>
    getMobileSignupIntroStepMs(getMobileSignupIntroBody(step))
  );
  const stepsDurationMs = stepDurations.reduce(
    (total, duration) => total + duration,
    0
  );
  const welcomeAtMs = stepsDurationMs + MOBILE_SIGNUP_INTRO_FINAL_DELAY_MS;

  return {
    steps: frozenSteps,
    stepDurations,
    welcomeAtMs,
    completeAtMs: welcomeAtMs + MOBILE_SIGNUP_INTRO_WELCOME_HOLD_MS,
  };
};
